<div class="signup-wrapper container mt-5">
    <!-- Logo centré -->
    <div class="text-center mb-4">
        <img src="/images/logo/Referio.png" alt="Logo" class="signup-logo" />
        <h2 class="signup-title">Créer un compte</h2>
        <p class="signup-subtitle">Rejoignez notre communauté en quelques secondes</p>
    </div>

    <form [formGroup]="signupForm" (ngSubmit)="onSubmit()" class="signup-form shadow p-4 rounded bg-white">
        <div class="row">
            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Prénom</mat-label>
                    <input matInput formControlName="firstName" />
                </mat-form-field>
            </div>
            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Nom</mat-label>
                    <input matInput formControlName="lastName" />
                </mat-form-field>
            </div>
        </div>

        <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Email</mat-label>
                <input matInput type="email" formControlName="email" />
            </mat-form-field>
        </div>

        <div class="row">
            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Mot de passe</mat-label>
                    <input matInput type="password" formControlName="password" />
                    @if(signupForm.get('password')?.hasError('required')){
                    <mat-error>Mot de passe requis</mat-error>
                    }
                    @if(signupForm.get('password')?.hasError('minlength')){
                    <mat-error>
                        Le mot de passe doit comporter au moins 8 caractères, inclure 1 lettre minuscule, 1 lettre
                        majuscule, 2 chiffres et 1 caractère spécial
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Confirmer le mot de passe</mat-label>
                    <input matInput type="password" formControlName="confirmPassword" />
                    @if(signupForm.get('confirmPassword')?.hasError('required')){
                    <mat-error>Confirmation requise</mat-error>
                    }
                    @if(signupForm.get('confirmPassword')?.hasError('passwordsMismatch')){
                    <mat-error>Les mots de passe ne correspondent pas</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>

        <div class="mb-3">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Téléphone</mat-label>
                <input matInput formControlName="phoneNumber" />
            </mat-form-field>
        </div>

        <fieldset formGroupName="address" class="signup-address mt-3">
            <legend class="address-title">Adresse</legend>
            <div class="row">
                <div class="col-md-8 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Rue</mat-label>
                        <input matInput formControlName="street" />
                    </mat-form-field>
                </div>
                <div class="col-md-4 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Numéro</mat-label>
                        <input matInput type="number" formControlName="number" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Ville</mat-label>
                        <input matInput formControlName="city" />
                    </mat-form-field>
                </div>
                <div class="col-md-3 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Code postal</mat-label>
                        <input matInput formControlName="zipCode" />
                    </mat-form-field>
                </div>
                <div class="col-md-3 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Pays</mat-label>
                        <input matInput formControlName="country" />
                    </mat-form-field>
                </div>
            </div>
        </fieldset>
        <div class="mb-3">
            <mat-checkbox  (change)="toggleProfessional($event)">
                Je suis un entrepreneur
            </mat-checkbox>
        </div>
        @if(isProfessional){
            <h4 class="mt-4">Choisissez votre plan</h4>

            <div class="row mt-3 plan-selector">
                <!-- BASIC -->
                <div class="col-md-6">
                    <div 
                        class="plan-card" 
                        [class.selected]="signupForm.get('company.plan')?.value === 'basic'"
                        (click)="selectPlan('basic')"
                    >
                        <h5>Basic</h5>

                        <p class="price"><s>100€/an</s></p>
                        <p class="price">3 mois gratuits</p>
                        <p class="sub-price">(≈ 8,33€/mois)</p>

                        <p class="desc">Visibilité standard</p>
                        <p class="desc">Limite de 1 société</p>
                        <p class="billing-info">Facturation annuelle</p>
                    </div>
                </div>

                <!-- PREMIUM -->
                <div class="col-md-6">
                    <div 
                        class="plan-card"
                        [class.selected]="signupForm.get('company.plan')?.value === 'premium'"
                        (click)="selectPlan('premium')"
                    >
                        <h5>Premium</h5>

                        <p class="price">150€/an</p>
                        <p class="sub-price">(≈ 12,50€/mois)</p>

                        <p class="desc">Visibilité boostée</p>
                        <p class="desc">Limite de 5 sociétés</p>
                        <p class="desc">Support prioritaire</p>
                        <p class="billing-info">Facturation annuelle</p>
                    </div>
                </div>
            </div>

            <!-- Formulaire société affiché uniquement si isProfessional -->
            <div formGroupName="company" class="company-form mt-4 p-3 border rounded">
            <h4>Informations sur la société</h4>
    
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Nom de la société</mat-label>
                <input matInput formControlName="companyName" />
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Numéro d’entreprise (ex: BE0123456789)</mat-label>
                <input matInput formControlName="companyNumber" />
                @if(signupForm.get('company.companyNumber')?.hasError('invalidTva')){
                    <mat-error>
                        {{ signupForm.get('company.companyNumber')?.getError('invalidTva') }}
                    </mat-error>
                }
                @if(signupForm.get('company.companyNumber')?.hasError('tvaError')){
                    <mat-error>
                        {{ signupForm.get('company.companyNumber')?.getError('tvaError') }}
                    </mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Votre role dans l'entreprise</mat-label>
                <input matInput formControlName="roleInCompany" />
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Email de la société</mat-label>
                <input matInput type="email" formControlName="companyEmail" />
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Téléphone de la société</mat-label>
                <input matInput formControlName="companyPhoneNumber" />
            </mat-form-field>

            <fieldset formGroupName="address" class="mt-3">
                <legend>Adresse de la société</legend>
                <div class="row">
                <div class="col-md-8 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Rue</mat-label>
                    <input matInput formControlName="street" />
                    </mat-form-field>
                </div>
                <div class="col-md-4 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Numéro</mat-label>
                    <input matInput type="number" formControlName="number" />
                    </mat-form-field>
                </div>
                </div>
                <div class="row">
                <div class="col-md-6 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Ville</mat-label>
                    <input matInput formControlName="city" />
                    </mat-form-field>
                </div>
                <div class="col-md-3 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Code postal</mat-label>
                    <input matInput formControlName="zipCode" />
                    </mat-form-field>
                </div>
                <div class="col-md-3 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Pays</mat-label>
                    <input matInput formControlName="country" />
                    </mat-form-field>
                </div>
                </div>
            </fieldset>
    
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Catégorie</mat-label>
                <mat-select formControlName="category">
                    @for (cat of categories; track $index) {
                        <mat-option [value]="cat">{{ cat }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
    
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Description (optionnel)</mat-label>
                <textarea matInput formControlName="description"></textarea>
            </mat-form-field>
            </div>
        }

        <div class="text-center mt-4">
            <small>déjà un compte ?</small>
            <a routerLink="/signin" class="ms-1">se connecter</a>
        </div>

        <div class="text-center mt-4">
            <button mat-raised-button color="primary" type="submit" class="signup-btn">
                S'inscrire
            </button>
            <a mat-raised-button routerLink="/" class="signup-btn mx-3">
                retour
            </a>
        </div>
    </form>
</div>